// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m1oT","colBig":"styles_colBig__2RDCE","colSmall":"styles_colSmall__3HaYI"};